import React, { useEffect, useState, useRef } from "react";
import {
  Scan,
  Camera,
  ArrowLeft,
  Search,
  Star,
  Clock,
  Plus,
  Gift,
  ArrowRight,
  Box,
  User,
  Mail,
  Phone,
  Calendar,
} from "lucide-react";
import axios from "axios";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import "./Loyalty.css";
import { toast } from "react-toastify";
import LoadingView from "../components/LoadingView/LoadingView";
import { fi } from "date-fns/locale";
import { set } from "date-fns";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

// Scroll wrapper
const TableScrollWrapper = ({ children }) => {
  const tableRef = useRef(null);
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);
  const [showHint, setShowHint] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const el = tableRef.current;
    if (!el) return;

    const checkScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = el;

      setShowLeftShadow(scrollLeft > 0);
      setShowRightShadow(scrollLeft + clientWidth < scrollWidth);
    };

    checkScroll(); // initial

    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);
  useEffect(() => {
    const el = tableRef.current;
    if (!el) return;

    setShowLeftShadow(false); // initially at left
    setShowRightShadow(el.scrollWidth > el.clientWidth); // show right icon if content overflow
  }, []);

  return (
    <div className="tableScrollWrapper">
      {/* 🔥 Scroll Hint */}
      <div className="scrollHint">
        {/* Always render icons if state is true */}
        {showLeftShadow && <ArrowLeft size={18} />}
        <span className="swipeText">Swipe</span>
        {showRightShadow && <ArrowRight size={18} />}
      </div>

      {/* 🔥 Scrollable Table */}
      <div
        className={`tableScrollContainer ${
          showLeftShadow ? "showLeftShadow" : ""
        } ${showRightShadow ? "showRightShadow" : ""}`}
        ref={tableRef} // 👈 move ref here for simpler logic
      >
        {children}
      </div>
    </div>
  );
};

const RestaurantLoyaltyView = () => {
  const { id } = useParams();

  const location = useLocation();

  const restaurant = localStorage.getItem("restaurant");
  const [restaurants, setRestaurant] = React.useState([]);
  const [selectedchildRestaurant, setselectedchildRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("restaurant")),
  );

  var res = JSON.parse(restaurant as string);
  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));

  const [customerData, setCustomerData] = useState(null);
  const [loyalty, setLoyalty] = useState([]);
  const [activeTab, setActiveTab] = useState("rewards");
  const [Loading, setLoading] = React.useState(false);
  const restaurantId = Restauranttoken.id;
  const [activeLoyaltySchemeIds, setActiveLoyaltySchemeIds] = useState([]);
  const [activeLoyaltySchemeId, setActiveLoyaltySchemeId] = useState(null);
  const [pointsToAdd, setPointsToAdd] = useState(1);
  const [pointToAdd, setPointToAdd] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isEditingPoints, setIsEditingPoints] = useState(false);
  const [editablePoints, setEditablePoints] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [orderHistory, setOrderHistory] = useState([]);
  const [redemptionHistory, setRedemptionHistory] = useState([]);

  const handleRestaurantSelect = async (props) => {
    console.log(props);
    var obj = {
      id: props.id,
      name: props.name,
      ulsHLfS: props.isHomeCook,
      FMlYe6C: props.subscriptionPlanId,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    window.location.reload();
  };

  const loadDataForRestaurant = async () => {
    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        response.data.map((dt, i) => {
          const isHomeCook = dt.isHomeCookToggle || false;
          let fallbackPlanId = isHomeCook ? 0 : -1;
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            isHomeCook: dt.isHomeCookToggle || false,
            subscriptionPlanId: dt.subscriptionPlanId || fallbackPlanId,
          };
          list.push(obj);
        });
        setRestaurant(list);
      });
  };

  useEffect(() => {
    loadDataForRestaurant();
  }, [restaurant]);

  const openAddPointsModal = (order) => {
    setSelectedOrder(order);
    setPointToAdd(1); // default 1
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedOrder(null);
    setPointToAdd(1);
  };

  // const loadLoyalty = async (customerLoyaltyData = []) => {
  //   try {
  //     setLoading(true);
  //     const res = await axios.get(
  //       `${apiAddress}/api/SubSection/GetLoyalitySchemeByRestaurantId/${restaurantId}`
  //     );

  //     const list = res.data.map(dt => {
  //   const matching = customerLoyaltyData.find(
  //     l => l.id === dt.id
  //   );

  //   return {
  //     id: dt.id,

  //     loyaltySchemeId: dt.id,
  //     name: dt.reward,
  //     description: dt.description || "Redeem this reward",
  //     pointsCost: matching ? matching.pointsCost : dt.orderAmount,
  //     category: "Reward",
  //     isActive: matching ? matching.isActive : false,
  //     redemptionId: matching ? matching.redemptionId : null
  //   };
  // });

  //     setLoyalty(list);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const loadLoyalty = async (customerLoyaltyData = []) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${apiAddress}/api/SubSection/GetLoyalitySchemeByRestaurantId/${restaurantId}`,
      );

      const list = res.data

        .filter((dt) => dt.isEnabled === true)
        .map((dt) => {
          const matching = customerLoyaltyData.find((l) => l.id === dt.id);

          return {
            id: dt.id,
            loyaltySchemeId: dt.id,
            name: dt.reward,
            description: dt.description || "Redeem this reward",
            pointsCost: matching ? matching.pointsCost : dt.orderAmount,
            category: "Reward",
            isActive: matching ? matching.isActive : false,
            redemptionId: matching ? matching.redemptionId : null,
          };
        });

      setLoyalty(list);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const refreshPoints = async () => {
    const pointsInfo = await fetchLoyaltyPoints(id, restaurantId);

    setCustomerData((prev) => ({
      ...prev,
      customer: {
        ...prev.customer,
        availablePoints: pointsInfo.availablePoints,
      },
      redemptions: [...pointsInfo.redeemedHistory],
      loyaltyPointsClass: [...pointsInfo.loyaltyPointsClass],
    }));

    await loadLoyalty(pointsInfo.loyaltySchemeClass);
  };

  const refreshOrders = async () => {
    const updatedOrders = await fetchOrderHistory(id, restaurantId);
    const updatePoints = await fetchLoyaltyPoints(id, restaurantId);

    setCustomerData((prev) => ({
      ...prev,
      orders: updatedOrders,
    }));
  };

  // Handle submit
  const handleAddPoints = async () => {
    const pts = Number(pointToAdd);

    if (!pts || pts < 1) {
      toast.error("Points must be at least 1");
      return;
    }

    try {
      setLoading(true);

      await axios.post(`${apiAddress}/api/SubSection/AddLoyaltyPoints`, {
        orderId: selectedOrder.orderId,
        points: pts,
        pointsType: 1,
        customerId: id,
        restaurantId,
        createdBy: "pointsAddByRestaurant",
      });

      toast.success("Points added successfully!");

      await refreshPoints(); // points update
      await refreshOrders(); // ✅ order history update

      closeModal();
    } catch (error) {
      toast.error("Failed to add points!");
    } finally {
      setLoading(false);
    }
  };

  const handleAddPointsByRestaurant = async () => {
    if (pointsToAdd < 1) return;

    try {
      setLoading(true);
      // Call your backend API to add points
      await axios.post(`${apiAddress}/api/SubSection/AddLoyaltyPoints`, {
        orderId: null,
        points: pointsToAdd,
        pointsType: 1,
        customerId: id,
        restaurantId: restaurantId,
        createdBy: "pointsAddByRestaurant",
      });

      toast.success("Points added successfully!");

      await refreshPoints();
      await refreshOrders();

      // Optionally refresh order history
      // fetchOrders();

      closeModal();
    } catch (error) {
      console.error(error);
      toast.error("Failed to add points!");
    } finally {
      fetchLoyaltyPoints(id, restaurantId);
      setLoading(false);
    }
  };

  const handleUpdateAvailablePoints = async () => {
    if (editablePoints < 0) return;

    try {
      setLoading(true);
      const diff = editablePoints - customer.availablePoints;

      if (diff === 0) {
        setIsEditingPoints(false);
        return;
      }

      await axios.post(`${apiAddress}/api/SubSection/AddLoyaltyPoints`, {
        orderId: null,
        points: Math.abs(diff),
        pointsType: diff > 0 ? 1 : 2, // 1 = add, 2 = deduct
        customerId: id,
        restaurantId: restaurantId,
        createdBy: "pointsAddByRestaurant",
      });

      toast.success("Points updated successfully");

      await refreshPoints();
      await refreshOrders();
      setIsEditingPoints(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to update points");
    } finally {
      setLoading(false);
    }
  };

  const fetchLoyaltyPoints = async (id, restaurantId) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${apiAddress}/api/SubSection/GetAvailableLoyaltyPoints/${id}/${restaurantId}`,
      );

      const loyaltyList =
        res.data.loyaltySchemeClass?.map((item) => ({
          id: item.loyaltySchemeId,
          isActive: item.isRedeemed === 0 && item.isClaimable === 1,
          pointsCost: item.redeemedPoints,
          redemptionId: item.id,
        })) || [];

      const redeemedHistory = res.data.redeemedHistory || [];
      const loyaltyPointsClass = res.data.loyaltyPointsClass || [];

      return {
        availablePoints: Number(res.data.availablePoints) || 0,
        loyaltySchemeClass: loyaltyList,
        redeemedHistory: redeemedHistory,
        loyaltyPointsClass: loyaltyPointsClass,
      };
    } catch (error) {
      console.error(error);
      return {
        availablePoints: 0,
        loyaltySchemeClass: [],
        redeemedHistory: [],
        loyaltyPointsClass: [],
      };
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerById = async (id) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${apiAddress}/api/SubSection/GetUserInfoById/${id}`,
      );

      return {
        id: res.data.id,
        name: `${res.data.firstName} ${res.data.lastName}`,
        userName: res.data.userName,
        email: res.data.email,
        phoneNumber: res.data.phoneNumber,
        joinedAt: res.data.creationTimestamp,
      };
    } catch (error) {
      console.error("Customer fetch failed", error);
      return {
        name: "Unknown Customer",
        userName: "N/A",
        email: "",
        phoneNumber: "",
        joinedAt: null,
      };
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderHistory = async (id, restaurantId) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${apiAddress}/api/SubSection/GetCustomerOrderHistoryForRestaurant/${id}/${restaurantId}`,
      );

      // API returns list of orders
      const orders = res.data;
      console.log("Fetched orders:", orders);

      return orders.map((order) => ({
        orderId: order.orderId,
        customerId: order.customerId,
        restaurantId: order.restaurantId,
        orderDateTime: order.orderDateTime, // spelling as per API
        restaurantName: order.restaurantName,
        restaurantLogo: order.restaurantLogo,
        totalAmount: order.totalAmount,
        loyaltyPoints: order.loyaltyPoints,
      }));
    } catch (error) {
      console.error("Order history fetch failed", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const handleRedeem = async (reward) => {
    try {
      setLoading(true);

      await axios.put(`${apiAddress}/api/SubSection/LoyaltyRedemptionUpdate`, {
        customerId: id,
        restaurantId,
        loyaltySchemeId: reward.loyaltySchemeId,
        id: reward.redemptionId,
        redemptionDate: new Date().toISOString(),
      });

      toast.success("Redeemed successfully!");

      await refreshPoints();
    } catch (error) {
      toast.error("Redeem failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerData?.customer?.availablePoints !== undefined) {
      setEditablePoints(customerData.customer.availablePoints);
    }
  }, [customerData]);

  // Load customer (works for direct URL + navigation)
  useEffect(() => {
    if (!id) return;

    const loadCustomerAndLoyalty = async () => {
      setLoading(true);

      const customerInfo = await fetchCustomerById(id);
      const pointsInfo = await fetchLoyaltyPoints(id, restaurantId);
      const OrderInfo = await fetchOrderHistory(id, restaurantId);

      await loadLoyalty(pointsInfo.loyaltySchemeClass);

      setCustomerData({
        customer: {
          id,
          name: customerInfo.name,
          userName: customerInfo.userName,
          email: customerInfo.email,
          phoneNumber: customerInfo.phoneNumber,
          joinedAt: customerInfo.joinedAt,
          availablePoints: pointsInfo.availablePoints,
        },
        redemptions: pointsInfo.redeemedHistory,
        loyaltyPointsClass: pointsInfo.loyaltyPointsClass,
        orders: OrderInfo,
      });

      setLoading(false);
    };

    loadCustomerAndLoyalty();
  }, [id]);

  const Navigate = useNavigate();

  useEffect(() => {
    loadLoyalty();
  }, []);

  if (!customerData)
    return (
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />
    );

  const { customer, rewards, redemptions, orders, loyaltyPointsClass } =
    customerData;
  // const canAfford = pts => pts <= customer.availablePoints;

  const formatDateTime = (d) =>
    new Date(d).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  const PlusIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );

  const filteredRedemptions = redemptions.filter((r) => {
    const text = searchText.toLowerCase();

    return (
      r.reward?.toLowerCase().includes(text) ||
      r.restaurantName?.toLowerCase().includes(text) ||
      r.redeemedPoints?.toString().includes(text) ||
      r.creationDate?.toString().includes(text)
    );
  });

  const loyaltyPointsClassFiltered = loyaltyPointsClass.filter((lp) => {
    const text = searchText.toLowerCase();

    return (
      lp.orderId?.toString().toLowerCase().includes(text) ||
      lp.points?.toString().includes(text) ||
      lp.pointsType?.toString().toLowerCase().includes(text) ||
      lp.creationDate?.toString().toLowerCase().includes(text) ||
      lp.createdBy?.toLowerCase().includes(text)
    );
  });

  const filteredOrders = orders.filter((order) => {
    const text = searchText.toLowerCase();

    return (
      order.orderId?.toLowerCase().includes(text) ||
      order.restaurantName?.toLowerCase().includes(text) ||
      order.totalAmount?.toString().includes(text) ||
      order.loyaltyPoints?.toString().includes(text)
    );
  });
  const getPointsTypeText = (lp) => {
    const pt = lp.pointsType?.toString();

    if (pt === "2") {
      return "Subtracted Point";
    }

    if (pt === "1" && lp.orderId) {
      return "Order Point";
    }

    if (pt === "1" && !lp.orderId) {
      return "Added Point";
    }

    return "N/A";
  };

  return (
    <div className="container">
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />
      <div className="content">
        <div className="backButtonWrapper">
          <button
            className="backBtn"
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_QR_CODE_URL_ADMIN}/loyalty-setup`;
            }}
          >
            <ArrowLeft size={18} />
            <span>Back</span>
          </button>
          <div className="restaurant-dropdown w-25">
            <FormControl className="w-100">
              <InputLabel id="demo-simple-select-label">
                {selectedchildRestaurant.name}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ marginLeft: "0px" }}
                label="Restaurant Name"
              >
                {restaurants.map((dt, i) => {
                  return (
                    <MenuItem
                      key={i}
                      style={{ background: "none" }}
                      onClick={() => {
                        handleRestaurantSelect(dt);
                      }}
                      selected={selectedchildRestaurant.name == dt.name}
                    >
                      {dt.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="mainLayout">
          <aside className="sidebar">
            <div className="customerCard">
              <div className="avatarWrapper">
                <div className="avatar">
                  <User size={28} />
                </div>
                <span className="statusDot"></span>
              </div>

              <h2 className="customerName">
                {customer.name
                  ?.split(" ")
                  .map((part, index, arr) =>
                    index === arr.length - 1
                      ? part.charAt(0).toUpperCase() + "."
                      : part,
                  )
                  .join(" ")}
              </h2>

              <p className="customerUsername">{customer.userName}</p>

              {/* <div className="infoRow">
    <div className="infoLeft">
      <Mail size={16} />
      <span>Email</span>
    </div>
    <span className="infoValue">
      {customer.email || "N/A"}
    </span>
  </div> */}

              {/* <div className="infoRow">
    <div className="infoLeft">
      <Phone size={16} />
      <span>Phone</span>
    </div>
    <span className="infoValue">
      {customer.phoneNumber || "N/A"}
    </span>
  </div> */}

              <div className="infoRow">
                <div className="infoLeft">
                  <Calendar size={16} />
                  <span>Joined</span>
                </div>
                <span className="infoValue">
                  {customer.joinedAt
                    ? formatDateTime(customer.joinedAt)
                    : "N/A"}
                </span>
              </div>
            </div>

            <div className="pointsCard">
              <p className="pointsLabel">Available Points</p>

              {!isEditingPoints ? (
                <>
                  <p className="pointsValue">{customer.availablePoints}</p>
                  <p className="pointsSuffix">points to redeem</p>

                  <button
                    className="pointsEditBtn"
                    onClick={() => {
                      setEditablePoints(customer.availablePoints);
                      setIsEditingPoints(true);
                    }}
                  >
                    Edit
                  </button>
                </>
              ) : (
                <>
                  <div className="pointsEditControls">
                    <button
                      className="pointsAdjustBtn"
                      onClick={() =>
                        setEditablePoints((prev) =>
                          Math.max(1, Number(prev) - 1),
                        )
                      }
                    >
                      −
                    </button>

                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className={`pointsInput`}
                      value={editablePoints}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value === "") {
                          setEditablePoints("");
                          return;
                        }
                        const num = Number(value);
                        if (num >= 1) setEditablePoints(num);
                      }}
                      onBlur={() => {
                        if (!editablePoints || editablePoints < 1) {
                          setEditablePoints(1);
                        }
                      }}
                    />

                    <button
                      className="pointsAdjustBtn"
                      onClick={() =>
                        setEditablePoints((prev) => Number(prev || 1) + 1)
                      }
                    >
                      +
                    </button>
                  </div>

                  <div className="pointsEditActions">
                    <button
                      className="btn-cancel pointsEditBtn m-2"
                      onClick={() => {
                        setEditablePoints(customer.availablePoints);
                        setIsEditingPoints(false);
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn-add pointsEditBtn"
                      onClick={handleUpdateAvailablePoints}
                      disabled={!editablePoints || editablePoints < 1}
                    >
                      Save
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="restaurant-add-points-card">
              <p className="restaurant-add-points-label">Add Points</p>

              <div className="restaurant-add-points-input-group">
                <button
                  className="pointsAdjustBtn"
                  onClick={() =>
                    setPointsToAdd((prev) => Math.max(1, Number(prev) - 1))
                  }
                >
                  −
                </button>

                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="restaurant-add-points-input"
                  placeholder="Points"
                  value={pointsToAdd}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // remove non-numeric
                    if (value === "") {
                      setPointsToAdd("");
                      return;
                    }
                    const num = Number(value);
                    if (num >= 1) setPointsToAdd(num);
                  }}
                  onBlur={() => {
                    if (!pointsToAdd || pointsToAdd < 1) setPointsToAdd(1);
                  }}
                />

                <button
                  className="pointsAdjustBtn"
                  onClick={() =>
                    setPointsToAdd((prev) => Number(prev || 1) + 1)
                  }
                >
                  +
                </button>

                <button
                  onClick={handleAddPointsByRestaurant}
                  className="restaurant-add-points-btn"
                  disabled={!pointsToAdd || pointsToAdd < 1}
                >
                  <PlusIcon />
                  Add
                </button>
              </div>
            </div>
          </aside>

          <main className="mainContent">
            <div className="tabs">
              <button
                className={`tab ${activeTab === "rewards" ? "tabActive" : ""}`}
                onClick={() => setActiveTab("rewards")}
              >
                <Gift size={18} /> Available Rewards
              </button>
              <button
                className={`tab ${activeTab === "PointsHistory" ? "tabActive" : ""}`}
                onClick={() => setActiveTab("PointsHistory")}
              >
                <Clock size={18} /> Points History
              </button>
              <button
                className={`tab ${activeTab === "history" ? "tabActive" : ""}`}
                onClick={() => setActiveTab("history")}
              >
                <Clock size={18} /> Redemption History
              </button>
              <button
                className={`tab ${activeTab === "OrderHistory" ? "tabActive" : ""}`}
                onClick={() => setActiveTab("OrderHistory")}
              >
                <Clock size={18} /> Order History
              </button>
            </div>
            {activeTab !== "rewards" && (
              <div className="search-wrapper">
                <Search size={18} className="search-icon" />
                <input
                  type="text"
                  placeholder="Search by Order ID / name / points"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="search-input"
                />
              </div>
            )}

            <div className="tabContent">
              {activeTab === "rewards" && (
                <div className="rewardsGrid">
                  {loyalty.map((r) => (
                    <div key={r.id} className="rewardCard">
                      <div className="rewardHeader">
                        <span className="rewardName">{r.name}</span>
                        <span className="rewardCategory">{r.category}</span>
                      </div>
                      <p className="rewardDescription">{r.description}</p>
                      <div className="rewardFooter">
                        <span>{r.pointsCost} pts</span>
                        <button
                          className={`redeemBtn ${r.isActive ? "redeemBtnEnabled" : "redeemBtnDisabled"}`}
                          disabled={!r.isActive}
                          onClick={() => handleRedeem(r)}
                        >
                          Redeem
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "history" && (
                <TableScrollWrapper>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Restaurant</th>
                        <th>Points</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRedemptions.length > 0 ? (
                        filteredRedemptions.map((r) => (
                          <tr key={r.id}>
                            <td>{r.reward}</td>
                            <td>{r.restaurantName}</td>
                            <td>-{r.redeemedPoints}</td>
                            <td>{formatDateTime(r.creationDate)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No redemption history found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </TableScrollWrapper>
              )}
              {activeTab === "OrderHistory" && (
                <TableScrollWrapper>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>OrderId</th>
                        <th>Restaurant</th>
                        <th>Total Amount</th>
                        <th>Points</th>
                        <th>Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredOrders.length > 0 ? (
                        filteredOrders.map((order, index) => (
                          <tr key={order.orderId || index}>
                            <td>
                              {order.orderId
                                ? order.orderId.slice(0, 6)
                                : "N/A"}
                            </td>

                            <td className="d-flex align-items-center gap-2">
                              <img
                                src={order.restaurantLogo}
                                alt={order.restaurantName}
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                              <span>{order.restaurantName}</span>
                            </td>

                            <td>{order.totalAmount}</td>

                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <span>{order.loyaltyPoints}</span>
                                {order.loyaltyPoints === 0 && (
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => openAddPointsModal(order)}
                                  >
                                    Add
                                  </button>
                                )}
                              </div>
                            </td>

                            <td>
                              {order.orderDateTime
                                ? formatDateTime(order.orderDateTime)
                                : "N/A"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No order history found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </TableScrollWrapper>
              )}
              {activeTab === "PointsHistory" && (
                <TableScrollWrapper>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>OrderId</th>
                        <th>Restaurant</th>

                        <th>Points</th>
                        <th>Points Type</th>
                        <th>Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loyaltyPointsClassFiltered.length > 0 ? (
                        loyaltyPointsClassFiltered.map((lp, index) => (
                          <tr key={lp.id || index}>
                            <td>
                              {lp.orderId ? lp.orderId.slice(0, 6) : "N/A"}
                            </td>

                            <td className="d-flex align-items-center gap-2">
                              {lp.createdBy}
                            </td>

                            {/* Points */}
                            <td>
                              {lp.pointsType === "1" || lp.pointsType === 1 ? (
                                <span className="text-success">
                                  +{lp.points}
                                </span>
                              ) : (
                                <span className="text-danger">
                                  -{lp.points}
                                </span>
                              )}
                            </td>

                            {/* Points Type */}
                            <td>
                              <span>{getPointsTypeText(lp)}</span>
                            </td>

                            <td>
                              {lp.creationDate
                                ? formatDateTime(lp.creationDate)
                                : "N/A"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No points history found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </TableScrollWrapper>
              )}

              {modalOpen && selectedOrder && (
                <div className="order-points-modal-backdrop">
                  <div className="order-points-modal-content">
                    <h5>Add Loyalty Points</h5>

                    <div>
                      <p>
                        <strong>OrderId:</strong> {selectedOrder.orderId}
                      </p>
                      <p>
                        <strong>Total Amount:</strong>{" "}
                        {selectedOrder.totalAmount}
                      </p>

                      <div>
                        <label>Points:</label>
                        <input
                          type="number"
                          min="1"
                          step="1"
                          value={pointToAdd}
                          onChange={(e) => {
                            const value = parseInt(e.target.value, 10);

                            if (isNaN(value)) {
                              setPointToAdd();
                            } else {
                              setPointToAdd(value);
                            }
                          }}
                        />
                      </div>

                      <div className="order-points-modal-buttons">
                        <button className="btn-cancel" onClick={closeModal}>
                          Cancel
                        </button>
                        <button
                          className="btn-add"
                          onClick={handleAddPoints}
                          disabled={!pointToAdd || pointToAdd < 1}
                        >
                          Add Points
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default RestaurantLoyaltyView;
